import React from 'react'
import { Card, CardContent, Typography } from '@mui/material'
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from '@mui/lab'
import { useTranslation } from 'react-i18next'

export default function TimelineCard({ events }) {
  const { t } = useTranslation()

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
          {t('listingManagement.timeline', 'Timeline')}
        </Typography>
        <Timeline position="alternate">
          {events.map((evt) => (
            <TimelineItem key={evt.id}>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <Typography variant="subtitle1" fontWeight="bold">
                  {evt.event_type.replace('_', ' ').toUpperCase()}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {new Date(evt.event_timestamp).toLocaleString()}
                </Typography>
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </CardContent>
    </Card>
  )
}
